import {
  Box,
  Table,
  TableBody,
  TableHead,
  TableContainer,
  Chip,
} from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../common/styles";
import { useAppSelector } from "../../app/hooks";
import { useEffect, useState } from "react";

import SpecialityService from "../../features/speciality/specialityService";
interface IProps {
  Data: any;
}
const OnlineAppoitment = ({ Data }: IProps) => {
  const { upComming }: any = useAppSelector((state) => state.speciality);
  const [UpCommingAp, setUpCommingAp] = useState(upComming);
  function getTagsList() {
    SpecialityService.getOnlineApo(Data?.id).then((response) => {
      setUpCommingAp(response);
    });
  }
  useEffect(() => {
    getTagsList();
  }, []);
  return (
    <TableContainer>
      <Box sx={{ minWidth: 1050, height: "800px" }}>
        <Table>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Id</StyledTableCell>
              <StyledTableCell>Date</StyledTableCell>
              <StyledTableCell>Time</StyledTableCell>
              <StyledTableCell>Booking Date</StyledTableCell>
              <StyledTableCell>Consultation Fee </StyledTableCell>
              <StyledTableCell>Payment Method</StyledTableCell>
              <StyledTableCell>Payment Status</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Notes</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {UpCommingAp.data?.map((patient: any) => (
              <StyledTableRow hover key={patient.id}>
                <StyledTableCell>{patient.id}</StyledTableCell>
                <StyledTableCell>{patient.date.slice(0, -14)}</StyledTableCell>
                <StyledTableCell>
                  <StyledTableCell>{patient.time}</StyledTableCell>
                </StyledTableCell>
                <StyledTableCell>
                  {patient.booking_date.slice(0, -14)}
                </StyledTableCell>
                <StyledTableCell>{patient.consultation_fee}</StyledTableCell>
                <StyledTableCell>
                  {" "}
                  {patient.payment_method === 0 ? (
                    <Chip
                      label="INCLINIC"
                      color="success"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : patient.payment_method === 1 ? (
                    <Chip
                      label="EASYPAISA"
                      color="success"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : patient.payment_method === 2 ? (
                    <Chip
                      label="JAZZCASH"
                      color="success"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : patient.payment_method === 3 ? (
                    <Chip
                      label="CREDITORDEBITCARD"
                      color="success"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : patient.payment_method === 4 ? (
                    <Chip
                      label="BANKTOBANK"
                      color="success"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : patient.payment_method === 5 ? (
                    <Chip
                      label="WALLET"
                      color="success"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : null}
                </StyledTableCell>
                <StyledTableCell>
                  {patient.payment_status === true ? (
                    <Chip
                      label="Cleared"
                      color="success"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : patient.payment_status === false ? (
                    <Chip
                      label="Pending"
                      color="info"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : null}
                </StyledTableCell>

                <StyledTableCell>
                  {patient.status === 0 ? (
                    <Chip
                      label="Pending"
                      color="info"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : patient.status === 1 ? (
                    <Chip
                      label="Approved"
                      color="success"
                      variant="outlined"
                      sx={{ width: "100px" }}
                    />
                  ) : patient.status === 2 ? (
                    <Chip
                      label="Rejected"
                      color="error"
                      variant="outlined"
                      sx={{ width: "80px" }}
                    />
                  ) : null}
                </StyledTableCell>
                <StyledTableCell>{patient.notes}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  );
};

export default OnlineAppoitment;
